import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type TransactionData = {
  transactionId: string;
  description: string;
  amount: number;
  date: string;
};

type FixedAssetModalState = {
  isOpen: boolean;
  transactionData: TransactionData | null;
};

const initialState: FixedAssetModalState = {
  isOpen: false,
  transactionData: null,
};

export const fixedAssetModalSlice = createSlice({
  name: "fixedAssetModal",
  initialState,
  reducers: {
    openFixedAssetModal: (state, action: PayloadAction<TransactionData>) => {
      state.isOpen = true;
      state.transactionData = action.payload;
    },
    closeFixedAssetModal: (state) => {
      state.isOpen = false;
      state.transactionData = null;
    },
  },
});

export const { openFixedAssetModal, closeFixedAssetModal } =
  fixedAssetModalSlice.actions;

export default fixedAssetModalSlice.reducer;
